import React, { useState } from "react";

const fmt = (iso) => (iso ? String(iso).slice(0, 16).replace("T", " ") : "—");

// Bloque compacto «Origen del correo» en la ficha de petición: correo de creación + histórico de actualizaciones por correo.
export function OrigenCorreoBlock({ peticion }) {
  const oc = peticion?.origen_correo;
  const hist = peticion?.historial_correos || [];
  const [open, setOpen] = useState(false);
  const [verCuerpo, setVerCuerpo] = useState(null);
  if (!oc && hist.length === 0) return null;
  return (
    <div className="border border-zinc-800 bg-zinc-900/40 rounded-lg p-3 text-xs" data-testid="origen-correo-block">
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between text-left" data-testid="origen-correo-toggle">
        <span className="font-semibold text-zinc-200">📩 Origen del correo</span>
        <span className="text-[10px] text-zinc-500">
          {oc ? `creada desde correo ${oc.fecha_email || fmt(oc.procesado_at).slice(0, 10)}` : "sin correo de origen"}{hist.length ? ` · ${hist.length} actualización(es) por correo` : ""} {open ? "▲" : "▼"}
        </span>
      </button>
      {open && (
        <div className="mt-2 space-y-2">
          {oc && (
            <div className="grid grid-cols-2 gap-x-3 gap-y-0.5 text-[11px]" data-testid="origen-correo-detalle">
              <div><span className="text-zinc-500">Asunto:</span> {oc.asunto_original || oc.asunto_normalizado || "—"}</div>
              <div><span className="text-zinc-500">Fecha correo:</span> {oc.fecha_email || oc.fecha_texto || "—"}</div>
              <div className="truncate" title={oc.remitente}><span className="text-zinc-500">De:</span> {oc.remitente || "—"}</div>
              <div className="truncate" title={oc.destinatarios}><span className="text-zinc-500">Para:</span> {oc.destinatarios || "—"}</div>
              <div><span className="text-zinc-500">Procesado:</span> {oc.aprobado_por || oc.procesado_por || "—"} · {fmt(oc.aprobado_at || oc.procesado_at)}</div>
              <div className="truncate font-mono" title={oc.hash}><span className="text-zinc-500 font-sans">Huella:</span> {(oc.hash || "").slice(0, 12)}…{oc.message_id ? ` · ${oc.message_id}` : ""}</div>
              {oc.duplicado_forzado && <div className="col-span-2 text-amber-300">⚠ Creada como nueva pese a coincidencia fuerte con otra petición (decisión explícita)</div>}
              {oc.cuerpo_original && (
                <div className="col-span-2">
                  <button type="button" className="text-sky-300 underline" onClick={() => setVerCuerpo(verCuerpo === "oc" ? null : "oc")} data-testid="origen-correo-ver-cuerpo">
                    {verCuerpo === "oc" ? "Ocultar correo original" : "Ver correo original"}
                  </button>
                  {verCuerpo === "oc" && <pre className="mt-1 max-h-48 overflow-auto whitespace-pre-wrap bg-zinc-950 border border-zinc-800 rounded p-2 text-[10px] text-zinc-300">{oc.cuerpo_original}</pre>}
                </div>
              )}
            </div>
          )}
          {hist.length > 0 && (
            <div data-testid="historial-correos">
              <div className="text-[10px] text-zinc-500 uppercase tracking-wider mb-1">Actualizaciones desde correo</div>
              <div className="space-y-1">
                {[...hist].reverse().map((h, i) => (
                  <div key={i} className="bg-zinc-950/60 rounded px-2 py-1 text-[11px]" data-testid={`historial-correo-${i}`}>
                    <span className="text-zinc-200">{h.asunto || "sin asunto"}</span>
                    <span className="text-zinc-500"> · correo {h.fecha_email || "—"} · {h.n_cambios} cambio(s) · {h.por} {fmt(h.at)}</span>
                    {h.reaplicado && <span className="ml-1 text-amber-300">· reaplicado</span>}
                    {(h.campos || []).length > 0 && <div className="text-[10px] text-zinc-500">Campos: {h.campos.join(", ")}</div>}
                    {h.cuerpo_original && (
                      <button type="button" className="text-sky-300 underline text-[10px]" onClick={() => setVerCuerpo(verCuerpo === i ? null : i)}>
                        {verCuerpo === i ? "Ocultar" : "Ver correo"}
                      </button>
                    )}
                    {verCuerpo === i && <pre className="mt-1 max-h-40 overflow-auto whitespace-pre-wrap bg-zinc-950 border border-zinc-800 rounded p-2 text-[10px] text-zinc-300">{h.cuerpo_original}</pre>}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
